/* Karta produktu - podglad gotowego GLB (modele robimy w Blenderze,
   przez Hyper3D; suwak rozmiaru NIE zmienia modelu - gotowy projekt
   wyglada tak, jak wyglada). Canvas: [data-sw-karta-glb][data-src].
   Orbit tak, zoom nie (konwencja viewera konfiguratora). Sekcja steruje
   przez window.SW3D.spin/reset - to samo API co wczesniej, tylko bez
   settera stanu. three.js z vendorowanych assetow (importmap w sekcji). */
const canvas = document.querySelector('[data-sw-karta-glb]');
if (canvas && canvas.dataset.src) {
  const scope = canvas.closest('.sw-kp') || document;
  const hint = scope.querySelector('[data-kp-hint]');
  const hintText = hint ? hint.textContent : '';
  let booted = false;
  function status(state, text) {
    canvas.dataset.sw3dState = state;
    canvas.setAttribute('aria-busy', state === 'loading' ? 'true' : 'false');
    if (hint) {
      hint.setAttribute('role', 'status');
      hint.textContent = text;
      hint.style.opacity = '';
    }
  }
  const boot = () => {
    /* Blokada PRZED importem: szybkie kliknięcia i Enter tworzą jedną scenę.
       Błąd zostaje w zakładce; zdjęcie i wybór smaku nadal działają. */
    if (booted) return;
    booted = true;
    status('loading', 'Ładowanie podglądu 3D...');
    init(canvas).then(() => {
      status('ready', hintText);
      const spin = scope.querySelector('[data-kp-spin]');
      if (spin) window.SW3D.spin(spin.getAttribute('aria-pressed') === 'true');
      document.dispatchEvent(new Event('sw3d-ready'));
    }).catch(() => {
      status('error', 'Nie udało się wczytać podglądu 3D. Wybierz Zdjęcie.');
    });
  };
  if (canvas.hasAttribute('data-autoload')) {
    /* konfigurator (?gotowiec=) - scena 3D jest głównym widokiem */
    boot();
  } else {
    scope.addEventListener('click', (e) => {
      if (e.target.closest('[data-kp-tab="3d"], [data-kp-thumb][data-view="3d"]')) boot();
    });
  }
}

async function init(canvas) {
  /* Importmap tylko wskazuje adresy. Biblioteki pobieramy dopiero tutaj,
     razem z zależnym bgutils; samo odroczenie GLB nie wystarczało. */
  const [THREE, { OrbitControls }, { GLTFLoader }] = await Promise.all([
    import('three'), import('three/orbitcontrols'), import('three/gltfloader')
  ]);
  const renderer = new THREE.WebGLRenderer({ canvas, antialias: true, alpha: true });
  renderer.setPixelRatio(Math.min(devicePixelRatio, 2));
  renderer.outputColorSpace = THREE.SRGBColorSpace;

  const scene = new THREE.Scene();
  const camera = new THREE.PerspectiveCamera(34, 1, 0.05, 50);

  const controls = new OrbitControls(camera, canvas);
  controls.enableDamping = true;
  controls.dampingFactor = 0.08;
  controls.enablePan = false;
  controls.enableZoom = false;
  controls.minPolarAngle = 0.45;
  controls.maxPolarAngle = 1.5;
  controls.autoRotate = true;
  controls.autoRotateSpeed = 0.7;

  /* scena podgladu jest ciemna (grafitowy stage), wiec swiatla ida mocno -
     tort ma byc jasny i wychodzic na wierzch (feedback 20.08) */
  scene.add(new THREE.AmbientLight(0xf4f1ea, 0.55));
  scene.add(new THREE.HemisphereLight(0xf4f1ea, 0x9a9284, 1.5));
  const key = new THREE.DirectionalLight(0xfff6e8, 2.6);
  key.position.set(0.42, 0.62, 0.36);
  scene.add(key);
  const fill = new THREE.DirectionalLight(0xf4f1ea, 1.1);
  fill.position.set(0.1, 0.35, 1);
  scene.add(fill);
  const rim = new THREE.DirectionalLight(0xd8c8a8, 1.0);
  rim.position.set(-0.5, 0.3, -0.42);
  scene.add(rim);

  let homePos = null, homeTarget = null;

  /* ── mapa otoczenia dla METALU ──
     Czysty metal w PBR nie ma składowej rozproszonej: odbija wyłącznie
     otoczenie. Scena ma same światła kierunkowe, więc złote kule i płatki
     renderowały się jak blady beton - dlatego wcześniejsze gotowce eksportowano
     z `metallicFactor: 0` i złoto było w nich wmalowane w teksturę.
     Ten sam mały gradient równoprostokątny, którego używa viewer konfiguratora
     (`sw-cake-viewer.js`, materiał Gold), daje metalowi ciepłe refleksy z każdej
     strony bez ładowania żadnego pliku HDR.

     PODPINAMY GO TYLKO TAM, GDZIE `metalness > 0`, a nie przez globalne
     `scene.environment`. To nie estetyka, tylko bezpieczeństwo: pięć gotowców
     wypuszczonych do 26.08.2026 ma `metallicFactor: 0` w każdym materiale,
     więc warunek ich nie łapie i wyglądają dokładnie tak, jak zostały
     zaakceptowane. Globalne środowisko rozjaśniłoby im też rozproszenie. */
  let envTex = null;
  function metalEnvMap() {
    if (envTex) return envTex;
    const ec = document.createElement('canvas');
    ec.width = 64;
    ec.height = 32;
    const ex = ec.getContext('2d');
    const eg = ex.createLinearGradient(0, 0, 0, ec.height);
    /* Gradient NEUTRALNY, nie złoty. Metal koloruje swoje odbicie sam
       (baseColor złota to jego reflektancja), więc otoczenie ma dawać tylko
       jasność i różnicę góra/dół. Złoty gradient działa w konfiguratorze,
       bo tam złoto ma WŁASNY materiał; tutaj cały tort jest jednym materiałem,
       więc złote otoczenie barwiło też krem - strona odwrócona od świateł
       robiła się musztardowa. Grunt też jaśniejszy: przy #5c4520 dolne odbicia
       wychodziły brudne. */
    eg.addColorStop(0, '#f7f4ee');      // „niebo" nad tortem
    eg.addColorStop(0.55, '#c9c5bd');
    eg.addColorStop(1, '#55524c');      // „grunt"
    ex.fillStyle = eg;
    ex.fillRect(0, 0, ec.width, ec.height);
    envTex = new THREE.CanvasTexture(ec);
    envTex.mapping = THREE.EquirectangularReflectionMapping;
    envTex.colorSpace = THREE.SRGBColorSpace;
    return envTex;
  }

  const gltf = await new GLTFLoader().loadAsync(canvas.dataset.src).catch((error) => {
    /* Nie zostawiamy renderera ani nasłuchów po błędzie pobierania modelu. */
    controls.dispose();
    renderer.dispose();
    throw error;
  });
  {
    const root = gltf.scene;
    scene.add(root);

    root.traverse(function (n) {
      const mats = n.material ? (Array.isArray(n.material) ? n.material : [n.material]) : [];
      mats.forEach(function (mt) {
        if (!mt || !('metalness' in mt) || !(mt.metalness > 0)) return;
        mt.envMap = metalEnvMap();
        mt.envMapIntensity = 1.0;
        mt.needsUpdate = true;
      });
    });

    /* kadrowanie z bboxa - modele gotowcow maja rozne skale */
    const box = new THREE.Box3().setFromObject(root);
    const size = box.getSize(new THREE.Vector3());
    const center = box.getCenter(new THREE.Vector3());
    const target = new THREE.Vector3(center.x, box.min.y + size.y * 0.48, center.z);
    const dist = Math.max(size.x, size.z) * 1.9 + size.y * 0.9;
    camera.position.set(target.x + dist * 0.62, target.y + dist * 0.52, target.z + dist * 0.78);
    camera.near = dist / 100;
    camera.far = dist * 20;
    camera.updateProjectionMatrix();
    controls.target.copy(target);
    homePos = camera.position.clone();
    homeTarget = target.clone();
    controls.update();
  }

  function resize() {
    const w = canvas.clientWidth || 1, h = canvas.clientHeight || 1;
    renderer.setSize(w, h, false);
    camera.aspect = w / h;
    camera.updateProjectionMatrix();
  }
  new ResizeObserver(resize).observe(canvas);
  resize();

  (function loop() {
    requestAnimationFrame(loop);
    controls.update();
    /* fill jedzie z kamerą - tort doświetlony z frontu przy każdym obrocie */
    fill.position.copy(camera.position);
    renderer.render(scene, camera);
  })();

  window.SW3D = {
    spin(on) { controls.autoRotate = on; },
    reset() {
      if (homePos) { camera.position.copy(homePos); controls.target.copy(homeTarget); }
      controls.update();
    }
  };
}
